export default __webpack_public_path__ + "static/media/SWT1370.34I-34996_-24482_0.f1249d5c.jpg";